import React from 'react';

interface TimelineGridProps {
    hours: number[];
    hourHeight: number;
    opacity30m: number;
    opacity15m: number;
}

/**
 * TimelineGrid: Visual background with graduated time markers.
 * SHADOW VERSION (.tsx)
 */
export const TimelineGrid: React.FC<TimelineGridProps> = ({
    hours,
    hourHeight,
    opacity30m,
    opacity15m
}) => {
    return (
        <div style={{ pointerEvents: 'none' }}>
            {hours.map(h => (
                <div 
                    key={h} 
                    data-is-grid="true"
                    style={{ 
                        height: `${hourHeight}px`, 
                        borderBottom: h === 23 ? 'none' : '1px solid #222', 
                        position: 'relative',
                        pointerEvents: 'auto'
                    }}
                >
                    {/* 30-Minute Line */}
                    <div style={{ position: 'absolute', top: '50%', left: '60px', right: 0, height: '1px', borderTop: '1px dashed #fff', opacity: opacity30m, transition: 'opacity 0.1s linear' }} />
                    
                    {/* 15-Minute Lines */}
                    <div style={{ position: 'absolute', top: '25%', left: '60px', right: 0, height: '1px', borderTop: '1px dotted #fff', opacity: opacity15m, transition: 'opacity 0.1s linear' }} />
                    <div style={{ position: 'absolute', top: '75%', left: '60px', right: 0, height: '1px', borderTop: '1px dotted #fff', opacity: opacity15m, transition: 'opacity 0.1s linear' }} />
                </div>
            ))}
        </div>
    );
};
